import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=602366f3"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('602366f3')) {
      api.createRecord('602366f3', component.options)
    } else {
      api.reload('602366f3', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=602366f3", function () {
      api.rerender('602366f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/student/Dashboard.vue"
export default component.exports